import { Group, Select } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import type { ReportParams, ReportPreset } from "../../api/reports";

const PRESETS: { value: ReportPreset; label: string }[] = [
  { value: "today", label: "Today" },
  { value: "last_7_days", label: "Last 7 days" },
  { value: "last_30_days", label: "Last 30 days" },
  { value: "this_month", label: "This month" },
  { value: "last_month", label: "Last month" },
  { value: "this_year", label: "This year" },
  { value: "last_year", label: "Last year" },
  { value: "custom", label: "Custom range" },
];

function toYmd(d: Date | null): string | undefined {
  if (!d) return undefined;
  return d.toISOString().slice(0, 10);
}

// Drives the report endpoints' preset/startDate/endDate query params.
export function DateRangePresetPicker({
  value,
  onChange,
}: {
  value: ReportParams;
  onChange: (next: ReportParams) => void;
}) {
  const isCustom = value.preset === "custom";

  return (
    <Group gap="sm" align="flex-end">
      <Select
        label="Period"
        data={PRESETS}
        value={value.preset ?? "last_30_days"}
        onChange={(v) =>
          onChange({ ...value, preset: (v as ReportPreset) ?? "last_30_days" })
        }
        allowDeselect={false}
        w={180}
      />
      {isCustom && (
        <>
          <DatePickerInput
            label="From"
            value={value.startDate ? new Date(value.startDate) : null}
            onChange={(d) => onChange({ ...value, startDate: toYmd(d as Date | null) })}
            w={160}
          />
          <DatePickerInput
            label="To"
            value={value.endDate ? new Date(value.endDate) : null}
            onChange={(d) => onChange({ ...value, endDate: toYmd(d as Date | null) })}
            w={160}
          />
        </>
      )}
    </Group>
  );
}
